import React, { useState } from "react";
import {
  Container,
  Title,
  Wrap,
  Input,
  TextArea,
  // Choose,
  // GoogleMapWrap,
  UploadInput,
  Label,
  Cancelimg,
} from "./style";
// import { GoogleMap, withScriptjs, withGoogleMap } from "react-google-maps";
import { useMutation } from "react-query";
import { useAxios } from "../../../../hooks/useAxios";

export const NewProperty = () => {
  const [details, setDetails] = useState({
    area: 0,
    bath: 0,
    room: 0,
    garage: 0,
  });
  const [state, setState] = useState({
    address: "",
    city: "",
    country: "",
    description: "",
    houseDetails: details,

    locationDto: {
      latitude: 0,
      longitude: 0,
    },
    name: "",
    price: 0,
    region: "",
    salePrice: 0,
    zipCode: "",
  });
  const handleInput = (e) => {
    const { name, value } = e.target;

    setState({
      ...state,
      [name]: Number(value) ? +value : value,
    });
  };

  const handleDetails = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setDetails({
      ...details,
      [name]: +value,
    });
    setState({
      ...state,
      houseDetails: details,
    });
  };
  const { request } = useAxios();
  const addHouse = useMutation((value) => {
    return request({ url: "/v1/houses", method: "POST", body: value });
  });
  // const apiKey = "AIzaSyC17GeRPQ0k7veGOvlta9Ts7fcy-vL-_BQ";
  // //REACT_APP_xxx_key >> access with ${process.env.REACT_APP_xxx_KEY}

  // const gmapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${apiKey}`;

  // will return library using, google map
  // function Map() {
  //   return (
  //     <GoogleMap defaultZoom={10} defaultCenter={{ lat: 37.75, lng: -122.5 }} />
  //   );
  // }

  // const WrappedMap = withScriptjs(withGoogleMap(Map));
  const {
    address,
    city,
    country,
    description,
    houseDetails,
    locationDto,
    name,
    price,
    region,
    salePrice,
    zipCode,
  } = state;
  const onSave = () => {
    if (
      (address,
      city,
      country,
      description,
      houseDetails,
      locationDto,
      name,
      price,
      region,
      salePrice,
      zipCode)
    ) {
      addHouse.mutate(
        {
          address,
          city,
          country,
          description,
          houseDetails,
          locationDto,
          name,
          price,
          region,
          salePrice,
          categoryId: 1,
          zipCode,
        },
        {
          onSuccess: (res) => {
            alert(res?.data?.message);
          },
        }
      );
    }
  };
  return (
    <Container>
      <Title>Add New Property</Title>
      <Title.Text>Ready to jump back in?</Title.Text>
      <Container.Box>
        <Container.Title>Contact Information</Container.Title>
        <Wrap>
          <Input.Wrap mr>
            <Input
              placeholder="House Title *"
              onChange={handleInput}
              name="name"
            />
          </Input.Wrap>
          <Input.Wrap>
            <Input.Title>Type</Input.Title>
            <Input placeholder="Property Type *" />
          </Input.Wrap>
        </Wrap>
        <Wrap>
          <TextArea
            placeholder="Property Description *"
            onChange={handleInput}
            name="description"
          />
        </Wrap>
        <Container.Title mrTop="50px">Price</Container.Title>
        <Wrap>
          <Input.Wrap mr>
            <Input placeholder="Price *" onChange={handleInput} name="price" />
          </Input.Wrap>
          <Input.Wrap>
            <Input
              placeholder="Sale Price"
              onChange={handleInput}
              name="salePrice"
            />
          </Input.Wrap>
        </Wrap>
        <Container.Title mrTop="50px">Location</Container.Title>
        <Wrap>
          <Input.Wrap mr>
            <Input
              placeholder="Country *"
              onChange={handleInput}
              name="country"
            />
          </Input.Wrap>
          <Input.Wrap>
            <Input placeholder="City" onChange={handleInput} name="city" />
          </Input.Wrap>
        </Wrap>
        <Wrap>
          <Input.Wrap mr>
            <Input
              placeholder="Region *"
              onChange={handleInput}
              name="region"
            />
          </Input.Wrap>
          <Input.Wrap>
            <Input
              placeholder="Zip Code"
              onChange={handleInput}
              name="zipCode"
            />
          </Input.Wrap>
        </Wrap>
        <Wrap>
          <Input.Wrap>
            <Input
              placeholder="Address"
              onChange={handleInput}
              name="address"
            />
          </Input.Wrap>
        </Wrap>
        <Container.Title mrTop="50px">House Details</Container.Title>
        <Wrap>
          <Input.Wrap mr>
            <Input
              placeholder="Area"
              name="area"
              type="number"
              onChange={handleDetails}
            />
          </Input.Wrap>
          <Input.Wrap mr>
            <Input
              placeholder="Bath"
              name="bath"
              type="number"
              onChange={handleDetails}
            />
          </Input.Wrap>
          <Input.Wrap mr>
            <Input
              placeholder="Room"
              name="room"
              type="number"
              onChange={handleDetails}
            />
          </Input.Wrap>
          <Input.Wrap>
            <Input.Wrap mr>
              <Input
                placeholder="Garage"
                name="garage"
                type="number"
                onChange={handleDetails}
              />
            </Input.Wrap>
          </Input.Wrap>
        </Wrap>
      </Container.Box>

      {/* <Container.Box>
        <Wrap>
          <GoogleMapWrap className="App">
            <WrappedMap
              googleMapURL={gmapURL}
              loadingElement={<div style={{ height: "100%" }} />}
              containerElement={<div style={{ height: "100%" }} />}
              mapElement={<div style={{ height: "100%" }} />}
            />
          </GoogleMapWrap>
        </Wrap>
        <Wrap>
          <Input.Wrap mr>
            <Input placeholder="Latidude" />
          </Input.Wrap>
          <Input.Wrap>
            <Input placeholder="Longitude" />
          </Input.Wrap>
        </Wrap>
      </Container.Box> */}

      <Container.Box>
        <Container.Title>Media</Container.Title>
        <Wrap>
          <Cancelimg.Wrap>
            <Input.Title>Featured Image</Input.Title>

            <Label>
              <UploadInput type="file" />
              Upload files
            </Label>
          </Cancelimg.Wrap>
        </Wrap>
      </Container.Box>
      <Container.Save onClick={onSave}>SAVE AND PREVIEW</Container.Save>
    </Container>
  );
};

export default NewProperty;
